import * as React from 'react';
import {useDispatch} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import type {ReportURLParams} from '../../reports/report-types';

import {CompaniesList} from './companies-list/companies-list';
import {openSidebar} from './visitors-sidebar/redux/actions';

type Props = {
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'visitors'>;
    onRemoveAllFilters: () => void;
};

export function VisitorsListPage(props: Props) {
    const dispatch = useDispatch();

    const onOpenSidebar = (id: string) => dispatch(openSidebar(id));

    // @ts-expect-error
    return <CompaniesList {...props} onOpenSidebar={(id: string) => onOpenSidebar(id)} />;
}
